module.exports = __webpack_public_path__ + "static/festivalofdangerousideasidentity-66ca5d6fcc6a107dccf3a6efc023d26c.jpg";